import { Fragment, memo, ReactElement } from 'react';
import ActiveStep from './active-step';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';
import { EccezioneVOList } from 'shell/models/practice';
import { PracticeDraftStep, TypeInitiative } from 'practice/constants/practice-management-step';

interface FormDetailProps {
  step?: number;
  identifierAnpr: string;
  typeRegister: string;
  yearId: string;
  progressive: string;
  idFamilyAnpr?: string;
  codeEnte?: string;
  typePractice?: string;
  intestatarioIsAnpr?: boolean;
  setIntestatarioIsAnpr: (value: boolean) => void;
  setTipoIniziativa: (value?: TypeInitiative) => void;
  iniziativa?: TypeInitiative;
  setStepBozza: (value: number) => void;
  stepBozza?: number;
  setCodOperatorePratica: (value: string) => void;
  codOperatorePratica?: string;
  onBack: (step?: PracticeDraftStep) => void;
  onNext: (step?: PracticeDraftStep) => void;
  ForPracticeTemporary?: boolean;
  eccezioni: EccezioneVOList;
  maxActiveStep?: number;
  setDisabledAll: (value: boolean) => void;
  disabledAll?: boolean;
  setIsAcceptMessi: (value: boolean) => void;
  setIsDisabledCancel: (value: boolean) => void;
  setStatoPratica: (value: string) => void;
  fromPerson?: TypeInitiative;
  setFromPerson: (value?: TypeInitiative) => void;
  stepRegisterOfficeState?: RegisterOfficeVM;
  setStepRegisterOfficeState: (values: RegisterOfficeVM) => void;
}

const FormDetailComponent = ({
  step,
  identifierAnpr,
  typeRegister,
  yearId,
  progressive,
  idFamilyAnpr,
  codeEnte,
  typePractice,
  ForPracticeTemporary,
  onBack,
  onNext,
  intestatarioIsAnpr,
  setIntestatarioIsAnpr,
  setTipoIniziativa,
  iniziativa,
  setStepBozza,
  stepBozza,
  setCodOperatorePratica,
  codOperatorePratica,
  eccezioni,
  maxActiveStep,
  setDisabledAll,
  disabledAll,
  setIsAcceptMessi,
  setIsDisabledCancel,
  setStatoPratica,
  setFromPerson,
  fromPerson,
  setStepRegisterOfficeState,
  stepRegisterOfficeState,
}: FormDetailProps): ReactElement => {
  return (
    <Fragment>
      <ActiveStep
        ForPracticeTemporary={ForPracticeTemporary}
        step={step}
        identifierAnpr={identifierAnpr}
        onBack={onBack}
        onNext={onNext}
        typeRegister={typeRegister}
        yearId={yearId}
        fromPerson={fromPerson}
        setFromPerson={setFromPerson}
        progressive={progressive}
        idFamilyAnpr={idFamilyAnpr}
        codeEnte={codeEnte}
        typePractice={typePractice}
        intestatarioIsAnpr={intestatarioIsAnpr}
        setIntestatarioIsAnpr={setIntestatarioIsAnpr}
        setTipoIniziativa={setTipoIniziativa}
        setStepBozza={setStepBozza}
        stepBozza={stepBozza}
        iniziativa={iniziativa}
        setCodOperatorePratica={setCodOperatorePratica}
        codOperatorePratica={codOperatorePratica}
        eccezioni={eccezioni}
        maxActiveStep={maxActiveStep}
        setDisabledAll={setDisabledAll}
        disabledAll={disabledAll}
        setIsAcceptMessi={setIsAcceptMessi}
        setIsDisabledCancel={setIsDisabledCancel}
        setStatoPratica={setStatoPratica}
        stepRegisterOfficeState={stepRegisterOfficeState}
        setStepRegisterOfficeState={setStepRegisterOfficeState}
      />
    </Fragment>
  );
};

FormDetailComponent.displayName = 'Practice Detail - Form component';

const FormDetail = memo(FormDetailComponent);

export default FormDetail;
